const THEME_VERSION = 'dieselr-2025-v1';

function clearOldCookiesAndStorage() {
  // Clear cookies
  document.cookie.split(";").forEach(cookie => {
    document.cookie = cookie
      .replace(/^ +/, "")
      .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  });

  // Clear local and session storage
  localStorage.clear();
  sessionStorage.clear();

  // Set the new theme version flag
  localStorage.setItem('themeVersion', THEME_VERSION);

  // Reload page
  location.reload();
}

window.triggerManualRefresh = clearOldCookiesAndStorage;

const currentVersion = localStorage.getItem('themeVersion');
if (currentVersion !== THEME_VERSION) {
  clearOldCookiesAndStorage();
}
